"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mapping = require("./mapping");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
var EbiSpeciesIcon = function EbiSpeciesIcon(_ref) {
  var species = _ref.species,
    groupColors = _ref.groupColors,
    color = _ref.color;
  var _lookUpIcon = (0, _mapping.lookUpIcon)(species),
    _lookUpIcon2 = _slicedToArray(_lookUpIcon, 2),
    group = _lookUpIcon2[0],
    icon = _lookUpIcon2[1];
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "icon icon-species",
    style: {
      color: color || groupColors[group] || "black"
    },
    "data-icon": icon || "\u2754",
    title: capitalizeFirstLetter(species)
  });
};
EbiSpeciesIcon.propTypes = {
  species: _propTypes["default"].string,
  groupColors: _propTypes["default"].shape({
    warmBlooded: _propTypes["default"].string,
    plants: _propTypes["default"].string,
    other: _propTypes["default"].string
  }),
  color: _propTypes["default"].string
};
EbiSpeciesIcon.defaultProps = {
  species: "oryctolagus cuniculus",
  //rabbit is objectively the best species
  groupColors: {
    warmBlooded: "indianred",
    plants: "mediumseagreen",
    other: "deepskyblue"
  }
};
var _default = exports["default"] = EbiSpeciesIcon;